/**
 * Popular Add Ons: replaces the checkbox selector inside the "product_bundle"
 * block (sections/main-product.liquid) with a per-item "Add to cart" button,
 * styled the same as the main product page's Add to cart button, and wires
 * it up to add just that item to the cart via AJAX.
 */
(function () {
  function addButtonMarkup(labelText) {
    // Customized built-in elements (is="hover-button") only upgrade to their
    // custom element class when created with the { is: ... } option passed
    // to createElement. Setting the "is" attribute afterwards on a plain
    // document.createElement('button') is inert, so the hover fill/reveal
    // animation JS never runs for the button (it stays inert). Try the
    // proper upgrade path first and gracefully fall back if unsupported.
    var button;
    try {
      button = document.createElement('button', { is: 'hover-button' });
    } catch (e) {
      button = document.createElement('button');
    }
    if (!button.getAttribute('is')) {
      button.setAttribute('is', 'hover-button');
    }
    button.type = 'button';
    button.className = 'button button--primary button--sm shrink-0';
    button.setAttribute('data-bundle-item-add', '');

    var fill = document.createElement('span');
    fill.className = 'btn-fill';
    fill.setAttribute('data-fill', '');

    var text = document.createElement('span');
    text.className = 'btn-text';
    text.textContent = labelText;

    button.appendChild(fill);
    button.appendChild(text);
    return button;
  }

  function upgradeRow(row, addToCartLabel) {
    if (row.dataset.bundleUpgraded) return;
    row.dataset.bundleUpgraded = '1';

    var checkbox = row.querySelector('input.checkbox[name="bundles"]');
    var variantId = checkbox ? checkbox.value : row.getAttribute('data-variant-id');
    var available = !checkbox || !checkbox.disabled;

    // Row no longer needs to act as a label for a checkbox.
    row.removeAttribute('for');
    row.removeAttribute('is');

    if (checkbox) checkbox.remove();

    var quantityWrap = row.querySelector('.horizontal-product__quantity');
    if (!quantityWrap) return;
    quantityWrap.classList.add('flex', 'items-center', 'gap-3');

    if (!available) return;

    var button = addButtonMarkup(addToCartLabel);
    button.dataset.variantId = variantId;
    quantityWrap.appendChild(button);
  }

  function handleAdd(button) {
    if (!button || button.hasAttribute('aria-disabled')) return;

    var row = button.closest('.product-bundle__info');
    var select = row ? row.querySelector('select[id^="Variants-"]') : null;
    var variantId = select && select.value ? select.value : button.dataset.variantId;
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');

    var routes = window.theme && window.theme.routes;
    var utils = window.theme && window.theme.utils;
    if (!routes || !utils) {
      button.removeAttribute('aria-disabled');
      button.removeAttribute('aria-busy');
      return;
    }

    fetch(routes.cart_add_url, Object.assign({}, utils.fetchConfig('javascript'), {
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }))
      .then(function (response) { return response.json(); })
      .then(function (parsedState) {
        if (parsedState.status) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: { errorMessage: parsedState.description }
          }));
          return;
        }

        return fetch(routes.cart_url, utils.fetchConfig('json', 'GET'))
          .then(function (response) { return response.json(); })
          .then(function (cartJson) {
            if (window.theme.pubsub) {
              window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-bundle-addon',
                cart: cartJson
              });
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));

            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') drawer.show(button);
          });
      })
      .catch(function (error) { console.log(error); })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
      });
  }

  function init() {
    var containers = document.querySelectorAll('[id^="ProductBundle-"]');
    if (!containers.length) return;

    var addToCartLabel = (document.querySelector('[data-product-bundle-submit] .btn-text span') || {}).textContent
      || (document.querySelector('.product-form__submit .btn-text span') || {}).textContent
      || 'Add to cart';

    containers.forEach(function (container) {
      var rows = container.querySelectorAll('.product-bundle__info');
      rows.forEach(function (row) { upgradeRow(row, addToCartLabel); });

      if (container.dataset.bundleAddonInit) return;
      container.dataset.bundleAddonInit = '1';
      container.addEventListener('click', function (event) {
        var button = event.target.closest('[data-bundle-item-add]');
        if (button) handleAdd(button);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the theme editor re-renders this section.
  document.addEventListener('shopify:section:load', init);

  // Glitch fix #16 (30 Oct 2026): the theme re-renders the product section after
  // a variant change or add-to-cart, which brings the original checkboxes back.
  // Watch for fresh, un-upgraded rows and convert them again.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    if (!document.querySelector('[id^="ProductBundle-"] .product-bundle__info:not([data-bundle-upgraded])')) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
